import React from "react";
import { nanoid } from "nanoid";

import Pagination from "./pagination";
import { BlogsPreview } from "./styled";
import BlogsCard from "./blogsCard";

const BlogWithPagination: React.FC<any> = ({ blogs, current, pages }) => {
  return (
    <BlogsPreview>
      {/* TO DO */}
      {/* <div className="tags">
        <button>დღის ბლოგები <FlexCenter>{closeSvg()}</FlexCenter></button>
      </div> */}

      {blogs.length && (
        <div className="grid ">
          {blogs.map((el, i) => {
            return (
              <BlogsCard key={nanoid()} el={el} big={i === 2 || i === 3} />
            );
          })}
        </div>
      )}

      <Pagination current={current - 1} pages={pages} />
    </BlogsPreview>
  );
};

export default BlogWithPagination;
